import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api, generic_put_api } from "api/generic_api";
import { Component } from "react";
import { Button, Form } from 'react-bootstrap';
import { CODE_LABELS } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { SfUseDistrict, Topics } from 'utils/sf_code_constants';


class CodeLabels extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parts: [],
            session_ok: false,
            working: false,
            search_sections: [],  // list of lists [[1, 2], [3]]
            combined_list: [], // list [1, 2, 3]
        };
        this.addToSearchSections = this.addToSearchSections.bind(this);
        this.fetchCodeParts = this.fetchCodeParts.bind(this);
        this.saveFiles = this.saveFiles.bind(this);
        this.resetEverythingAndFetch = this.resetEverythingAndFetch.bind(this);
        this.addToCombinedList = this.addToCombinedList.bind(this);
        this.isInCombinedList = this.isInCombinedList.bind(this);
        this.isInSearchSections = this.isInSearchSections.bind(this);
        this.removeFromSearchSections = this.removeFromSearchSections.bind(this);
        this.mergeCombinedList = this.mergeCombinedList.bind(this);
    }

    resetEverythingAndFetch() {
        this.setState({ parts: [] }, this.fetchCodeParts);
    }

    fetchCodeParts() {
        this.setState({working: true });

        generic_get_api(CODE_LABELS, {section: this.state.section})
        .then(
            data => { 
                this.setState({
                    parts: data.parts,
                    working: false,
                })
            }
        )
        .catch(error => {
        });
    }

    saveFiles() {
        this.setState({working: true });
        generic_put_api(CODE_LABELS, 
            {   
                search_groups: this.state.search_sections,
            })
            .then(
                (result) => {
                    if(result.status === 204) {
                        this.setState(
                            {
                                working: false,
                                parts: [],
                                search_sections: [],  // list of lists [[1, 2], [3]]
                                combined_list: [], // list [1, 2, 3]
                            });
                    }
                }
            ).catch(error => {
            });
    }

    addToSearchSections(part) {
        let cur_search_sections = this.state.search_sections;
        cur_search_sections.push([part]);
        this.setState({search_sections: cur_search_sections});
    }

    removeFromSearchSections(part) {
        let cur_search_sections = this.state.search_sections;
        
        let new_search_sections = [];

        for (let i = 0; i < cur_search_sections.length; i++) {
            let curr_list = cur_search_sections[i];

            let skip = false;

            for (let j = 0; j < curr_list.length; j++) {
                let curr_part = curr_list[j];
                
                if (curr_part.order == part.order){
                    skip = true;
                }
            }
            if (! skip) {
                new_search_sections.push(curr_list);
            }
        }
        this.setState({search_sections: new_search_sections});
    }

    addToCombinedList(part, value){

        let curr_combined_list = this.state.combined_list;

        let new_combined_list = [];
        let i = 0;

        for (i; i < curr_combined_list.length; i++) {
            let curr_part = curr_combined_list[i];
            if (curr_part.order !== part.order) {
                new_combined_list.push(curr_part);
            }
        }
        if (value) {
            new_combined_list.push(part);
        }

        this.setState({combined_list: new_combined_list});
    }

    mergeCombinedList() {

        let new_list = [];

        for(let i = 0; i < this.state.combined_list.length; i++) {
            new_list.push(this.state.combined_list[i]);
        }

        let curr_sections = this.state.search_sections;
        curr_sections.push(new_list);

        this.setState({
            combined_list: [],
            search_sections: curr_sections,
        });
    }

    isInCombinedList(part){
        let curr_combined_list = this.state.combined_list;
        let i = 0;

        for (i; i < curr_combined_list.length; i++) {
            let curr_part = curr_combined_list[i];
            if (curr_part.order === part.order) {
                return true;
            }
        }

        return false;
    }

    isInSearchSections(part) {
        let curr_sections = this.state.search_sections;

        for (let i = 0; i < curr_sections.length; i++) {
            let curr_list = curr_sections[i];

            for (let j = 0; j < curr_list.length; j++) {
                let curr_part = curr_list[j];
                
                if (curr_part.order == part.order){
                    return true;
                }
            }
        }
        return false;
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_parts'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true});
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });

    }

    render() {
        const {parts, working, section, combined_list} = this.state;
        
        const getID = (part, str) => {
            return part.ID + part.order + str;
        }

        const getStyle = (part) => {

            if (this.isInSearchSections(part)){
                return "row mt-3 bg-secondary";
            }
            else if (this.isInCombinedList(part)){
                return "row mt-3 bg-warning";
            }
            else{
                return "row mt-3";
            }
        }

        const getMargin = (part) => {

            if(part.level === 1){
                return "row ms-2";
            }
            else if(part.level === 2){
                return "row ms-4";
            }
            else if(part.level === 3){
                return "row ms-5";
            }
            else {
                return "row";
            }
        }

        return(
            <div class="container-fluid codeLabel ps-4">
                {this.state.session_ok && 
                    <div class="row">
                        <div class="col-auto me-3">
                            <input type="text" class="form-control" value={section} placeholder="section" onChange={(e) => this.setState({section: e.target.value})}/> 
                            
                        </div>
                        <div class="col-auto me-3 text-start"><Button variant="secondary" onClick={ this.resetEverythingAndFetch }>OK</Button></div>
                    </div>
                }

                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                
                {  
                    <>
                        {parts.map((part, index) => {
                            return <div class={getStyle(part)}>
                                    <div class="row mt-2">
                                        <div class="col-10">
                                            <div class={getMargin(part)}>
                                                {
                                                    part.level === 0 ? 
                                                    <>
                                                        <div class="col">{part.text}</div>
                                                    </>
                                                    :
                                                    <>
                                                        { part.subsection ?
                                                            <div class="col-1 pe-0 subsection">({part.subsection})</div>
                                                            :
                                                            <div class="col-1 pe-0 subsection">&nbsp;&nbsp;&nbsp;</div>
                                                        }
                                                        
                                                        <div class="col">{part.text}</div>
                                                    </>
                                                   
                                                }
                                            </div>
                                        </div>

                                        {
                                            part.order !== 0 &&
                                            <>
                                                <div class="col-auto">
                                                    <input class="form-check-input" type="checkbox" disabled={this.isInSearchSections(part)} checked={this.isInCombinedList(part)} id={getID(part, 'add_to_combined')} onChange={(e) => this.addToCombinedList(part, e.currentTarget.checked)}/>
                                                </div>
                                                {
                                                    !this.isInCombinedList(part) && 
                                                        <div class="col-auto">
                                                            {
                                                                this.isInSearchSections(part) ?
                                                                <Button onClick={() => this.removeFromSearchSections(part)} disabled={combined_list.length > 0 }><i class="fa-solid fa-minus"></i></Button> 
                                                                :
                                                                <Button onClick={() => this.addToSearchSections(part)} disabled={combined_list.length > 0}><i class="fa-solid fa-plus"></i></Button>
                                                            }
                                                            
                                                        </div>
                                                }
                                                {
                                                    this.isInCombinedList(part) &&
                                                    <div class="col-auto"><Button variant="success" onClick={this.mergeCombinedList} ><i class="fa-solid fa-plus"></i></Button></div>
                                                }
                                            </>
                                        }
                                        
                                    </div>
                                    <div class="row"><div class="col"><hr></hr></div></div>
                                </div>  
                        })}
                    </>
                }
                {
                    parts && parts.length > 0 &&
                    <div class="row mt-4"><div class="col"><Button onClick={this.saveFiles}>Save</Button></div></div>
                }
            </div>
        )
    }
}

export default CodeLabels;